import { useLocation, useNavigate, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@features/auth';
import { useAbility } from '@features/authorization';
import { canAccessPersonalFlow } from '@shared/lib';
import { SectionTabs } from '@shared/ui';

interface StudentSectionTabsProps {
  locale?: string;
}

export function StudentSectionTabs({ locale }: StudentSectionTabsProps) {
  const params = useParams({ strict: false });
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useAuth();
  const ability = useAbility();

  const resolvedLocale =
    locale ??
    ('locale' in params && typeof params.locale === 'string' ? params.locale : undefined) ??
    'en';
  const localePrefix = `/${resolvedLocale}`;

  const navItems = [
    ...(canAccessPersonalFlow(ability, user?.id ?? null)
      ? [{ id: `${localePrefix}/student/personal-flow`, label: t('student.personalFlow') }]
      : []),
    { id: `${localePrefix}/student/my_courses`, label: t('student.myCourses') },
  ];

  const activeNavId =
    navItems.find((item) => location.pathname === item.id || location.pathname === `${item.id}/`)
      ?.id ??
    navItems.find((item) => location.pathname.startsWith(`${item.id}/`))?.id ??
    navItems[0]?.id;

  return (
    <div className="mb-6">
      <SectionTabs
        items={navItems}
        activeId={activeNavId}
        onSelect={(id) => {
          if (!id) {
            return;
          }
          void navigate({ to: id });
        }}
      />
    </div>
  );
}
